import './globals';
import './bootstrap';

// Load jquery
import $ from 'jquery';
// Load bootstrap
import 'bootstrap-sass';
// Load jquery slimscroll
import 'jquery-slimscroll';
// Require icheck
import 'admin-lte/plugins/iCheck/icheck.min';

// Boot some jquery things
$(document).ready(function () {

    if (isMSIE()) {
        $("#beoverlay").removeClass("hidden");
    }

    $('.i-checks').iCheck({
        checkboxClass: 'icheckbox_minimal-orange',
        radioClass: 'iradio_minimal-orange'
    });
});

function isMSIE(){
    let ua = window.navigator.userAgent;
    let msie = ua.indexOf("MSIE ");
    return msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./);
}
